<script lang="ts">export let size = "20";
const height = size;
</script>

<svg
	{height}
	style="fill: currentColor"
	viewBox="0 -4.5 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M6.06549 0.42578C5.95284 0.732713 5.88923 1.06406 5.88923 1.4109V3.70492L3.09349 4.46684C2.74532 4.56173 2.5392 4.92588 2.63251 5.27973C2.72589 5.63335 3.08304 5.84272 3.4311 5.74818L4.16325 5.54978C5.03473 5.31249 5.85956 6.0629 5.72247 6.9689L5.20996 10.3417C5.14232 10.7871 5.47751 11.1661 5.88923 11.1836V13.5892C5.88923 13.8774 5.93223 14.1553 6.01126 14.4172L4.36527 14.8664C3.6987 15.0479 3.01313 14.6454 2.83453 13.9681L0.0428545 3.38114C-0.135754 2.70376 0.260275 2.00712 0.926862 1.82561L6.06549 0.42578Z"
	/>
	<path
		d="M23.0731 1.82561C23.7397 2.00712 24.1358 2.70376 23.9571 3.38114L21.1655 13.9681C20.9868 14.6454 20.3013 15.0479 19.6347 14.8664L18.4253 14.5357C18.5292 14.2395 18.5894 13.9217 18.5894 13.5892V9.18026L21.1492 5.83498C21.2221 5.7397 21.2757 5.63052 21.3065 5.51396C21.4339 5.03086 21.1514 4.53428 20.676 4.40484L18.5894 3.83581V1.4109C18.5894 1.11768 18.545 0.834947 18.4633 0.56907L23.0731 1.82561Z"
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M17.201 13.5892C17.201 14.3684 16.5791 15 15.8123 15H8.66566C7.89888 15 7.27761 14.3684 7.27761 13.5892V1.4109C7.27761 0.631705 7.89888 0 8.66566 0H15.8123C16.5791 0 17.201 0.631705 17.201 1.4109V13.5892ZM10.2439 3.4679C9.84325 3.4679 9.51848 3.79792 9.51848 4.20502C9.51848 4.61211 9.84325 4.94213 10.2439 4.94213H11.0858C12.0885 4.94213 12.7606 5.98925 12.3563 6.92176L10.853 10.3913C10.6201 10.9286 11.0064 11.5321 11.5841 11.5321C11.9058 11.5321 12.1962 11.3363 12.3212 11.0351L14.8825 4.86502C14.9338 4.74139 14.9598 4.60788 14.9598 4.47373C14.9598 3.91801 14.5161 3.4679 13.9693 3.4679H10.2439Z"
	/>
</svg>
